import React, { useEffect } from 'react';
import { TextReveal } from '../components/TextReveal';
import { SubpageHeader } from '../components/SubpageHeader';
import { CTA } from '../components/CTA';
import { SEO } from '../components/SEO';
export function Datenschutz() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <SEO title="Datenschutzerklärung – PP Management & Consulting" description="Datenschutzerklärung der PP Immobilien & Managment GmbH. Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO." canonical="https://ppimpact.com/datenschutz" noindex data-id="element-129" />
      <SubpageHeader data-id="element-130" />
      <main className="pt-40 pb-24 md:pt-56 md:pb-32 min-h-screen" data-id="element-131">
        <div className="container mx-auto px-6 md:px-12 max-w-8xl" data-id="element-132">
          <div className="mb-16 md:mb-24" data-id="element-133">
            <TextReveal text="DATENSCHUTZ" as="h1" className="text-[clamp(3rem,6vw,6rem)] font-black leading-[0.9] tracking-tighter text-white mb-4" data-id="element-134" />
          </div>

          <div className="space-y-12 text-muted text-lg leading-relaxed" data-id="element-135">
            <section data-id="element-136">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-137">
                Verantwortlicher
              </h2>
              <p className="mb-4" data-id="element-138">
                Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere
                der EU-Datenschutz-Grundverordnung (DSGVO), ist:
              </p>
              <p data-id="element-139">PP Immobilien & Managment GmbH</p>
              <p data-id="element-140">Grüner Weg 59A 12359 Berlin</p>
              <p data-id="element-141">Handelsregister: HRB 218746 B</p>
              <p data-id="element-142">Registergericht: Amtsgericht Charlottenburg (Berlin)</p>
              <p className="mt-2" data-id="element-143">
                Vertreten durch den geschäftsführenden Gesellschafter: Philip
                Michael Steinke
              </p>
            </section>

            <section data-id="element-144">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-145">
                Ihre Betroffenenrechte
              </h2>
              <p className="mb-4" data-id="element-146">
                Unter den angegebenen Kontaktdaten können Sie gemäß
                EU-Datenschutz-Grundverordnung (DSGVO) jederzeit folgende Rechte
                ausüben:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-147">
                <li data-id="element-148">
                  Auskunft über Ihre bei uns gespeicherten Daten und deren
                  Verarbeitung (Art. 15 DSGVO),
                </li>
                <li data-id="element-149">
                  Berichtigung unrichtiger personenbezogener Daten (Art. 16
                  DSGVO),
                </li>
                <li data-id="element-150">
                  Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),
                </li>
                <li data-id="element-151">
                  Einschränkung der Datenverarbeitung, sofern wir Ihre Daten
                  aufgrund gesetzlicher Pflichten noch nicht löschen dürfen
                  (Art. 18 DSGVO),
                </li>
                <li data-id="element-152">
                  Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art.
                  21 DSGVO) und
                </li>
                <li data-id="element-153">
                  Datenübertragbarkeit, sofern Sie in die Datenverarbeitung
                  eingewilligt haben oder einen Vertrag mit uns abgeschlossen
                  haben (Art. 20 DSGVO).
                </li>
              </ul>
              <p className="mb-4" data-id="element-154">
                Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese
                jederzeit mit Wirkung für die Zukunft widerrufen.
              </p>
              <p className="mb-4" data-id="element-155">
                Sie können sich jederzeit mit einer Beschwerde an eine
                Aufsichtsbehörde wenden, z. B. an die zuständige
                Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die
                für uns als verantwortliche Stelle zuständige Behörde.
              </p>
              <p data-id="element-156">
                Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen
                Bereich) mit Anschrift finden Sie unter:
                bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
              </p>
            </section>

            <div className="h-px w-full bg-white/10 my-12" data-id="element-157" />

            <section data-id="element-158">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-159">
                Verarbeitungstätigkeiten
              </h2>

              <div className="space-y-10" data-id="element-160">
                <div data-id="element-161">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-162">
                    Erfassung allgemeiner Informationen beim Besuch unserer
                    Website
                  </h3>
                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-163">
                    Art und Zweck der Verarbeitung
                  </h4>
                  <p className="mb-4" data-id="element-164">
                    Wenn Sie auf unsere Website zugreifen, d.h., wenn Sie sich
                    nicht registrieren oder anderweitig Informationen
                    übermitteln, werden automatisch Informationen allgemeiner
                    Natur erfasst. Diese Informationen (Server-Logfiles)
                    beinhalten etwa die Art des Webbrowsers, das verwendete
                    Betriebssystem, den Domainnamen Ihres
                    Internet-Service-Providers, Ihre IP-Adresse und ähnliches.
                  </p>
                  <p className="mb-2" data-id="element-165">
                    Sie werden insbesondere zu folgenden Zwecken verarbeitet:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mb-4" data-id="element-166">
                    <li data-id="element-167">
                      Sicherstellung eines problemlosen Verbindungsaufbaus der
                      Website
                    </li>
                    <li data-id="element-168">
                      Sicherstellung einer reibungslosen Nutzung der Website
                    </li>
                    <li data-id="element-169">
                      Sicherstellung und Auswertung der Systemsicherheit und
                      -stabilität, insbesondere zur Missbrauchserkennung
                    </li>
                    <li data-id="element-170">
                      zur technisch fehlerfreien Darstellung und Optimierung der
                      Website
                    </li>
                  </ul>
                  <p className="mb-4" data-id="element-171">
                    Wir verwenden Ihre Daten nicht, um Rückschlüsse auf Ihre
                    Person zu ziehen. Allerdings behalten wir uns vor, die
                    Server-Logfiles nachträglich zu überprüfen, sollten konkrete
                    Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-172">
                    Rechtsgrundlage und berechtigtes Interesse
                  </h4>
                  <p className="mb-4" data-id="element-173">
                    Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO
                    auf Basis unseres berechtigten Interesses an der
                    Verbesserung der Stabilität und Funktionalität unserer
                    Website sowie der Sicherstellung der Systemsicherheit und
                    Missbrauchserkennung.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-174">
                    Empfänger
                  </h4>
                  <p className="mb-4" data-id="element-175">
                    Empfänger der Daten sind ggf. technische Dienstleister, die
                    für den Betrieb und die Wartung unserer Webseite als
                    Auftragsverarbeiter tätig werden.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-176">
                    Speicherdauer
                  </h4>
                  <p className="mb-4" data-id="element-177">
                    Daten werden in Server-Log-Dateien in einer Form, die die
                    Identifizierung der betroffenen Personen ermöglicht, maximal
                    für 14 Tage gespeichert; es sei denn, dass ein
                    sicherheitsrelevantes Ereignis auftritt (z.B. ein
                    DDoS-Angriff). Im Falle eines solchen Ereignisses werden
                    Server-Log-Dateien bis zur Beseitigung und vollständigen
                    Aufklärung des sicherheitsrelevanten Ereignisses
                    gespeichert.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-178">
                    Bereitstellung vorgeschrieben oder erforderlich
                  </h4>
                  <p className="mb-4" data-id="element-179">
                    Die Bereitstellung der vorgenannten personenbezogenen Daten
                    ist weder gesetzlich noch vertraglich vorgeschrieben. Ohne
                    die IP-Adresse ist jedoch der Dienst und die
                    Funktionsfähigkeit unserer Website nicht gewährleistet.
                    Zudem können einzelne Dienste und Services nicht verfügbar
                    oder eingeschränkt sein.
                  </p>
                </div>

                <div data-id="element-180">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-181">
                    Kontaktaufnahme
                  </h3>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-182">
                    per E-Mail, Telefon oder Telefax sowie Audio- und
                    Videokonferenzen
                  </h4>
                  <p className="mb-4" data-id="element-183">
                    Wenn Sie uns per E-Mail, Chatfunktion, Telefon oder Telefax
                    kontaktieren, wird Ihre Anfrage inklusive aller daraus
                    hervorgehenden personenbezogenen Daten (Name, Anfrage) zum
                    Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert
                    und verarbeitet. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter. Die Daten können in einem
                    Customer-Relationship-Management System
                    (&quot;CRM-System&quot;) oder vergleichbarer
                    Anfragenorganisation gespeichert werden.
                  </p>
                  <p className="mb-4" data-id="element-184">
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art.
                    6 Abs. 1 lit. b DS-GVO, sofern Ihre Anfrage mit der
                    Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
                    vorvertraglicher Maßnahmen erforderlich ist. In allen
                    übrigen Fällen beruht die Verarbeitung auf unserem
                    berechtigten Interesse an der effektiven Bearbeitung der an
                    uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DS-GVO) oder
                    auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DS-GVO), sofern
                    diese abgefragt wurde.
                  </p>
                  <p className="mb-4" data-id="element-185">
                    Die von Ihnen an uns per Kontaktanfragen übersandten Daten
                    verbleiben bei uns, bis Sie uns zur Löschung auffordern,
                    Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
                    für die Datenspeicherung entfällt (z. B. nach
                    abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
                    gesetzliche Bestimmungen – insbesondere gesetzliche
                    Aufbewahrungsfristen – bleiben unberührt.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-186">
                    Art und Zweck der Verarbeitung
                  </h4>
                  <p className="mb-4" data-id="element-187">
                    Auf unserer Website ist ein Kontaktformular vorhanden,
                    welches für die elektronische Kontaktaufnahme genutzt werden
                    kann. Nimmt ein Nutzer diese Möglichkeit wahr, so werden die
                    in der Eingabemaske eingegeben Daten an uns übermittelt und
                    gespeichert.
                  </p>
                  <p className="mb-2" data-id="element-188">
                    Zum Zeitpunkt der Absendung der Nachricht werden zudem
                    folgende Daten gespeichert:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mb-4" data-id="element-189">
                    <li data-id="element-190">IP-Adresse des anfragenden Geräts</li>
                    <li data-id="element-191">Datum und Uhrzeit der Anfrage</li>
                    <li data-id="element-192">URL, von der die Anfrage erfolgte</li>
                  </ul>
                  <p className="mb-4" data-id="element-193">
                    Eine Kontaktaufnahme ist über die bereitgestellten
                    E-Mail-Adressen möglich. In diesem Fall werden die mit der
                    E-Mail übermittelten personenbezogenen Daten des Nutzers
                    gespeichert. Hierzu zählen Datum und Uhrzeit des
                    E-Mailversands, E-Mailadresse, IP-Adressen sowie
                    Informationen zu den an der E-Mail-Kommunikation beteiligten
                    Servern.
                  </p>
                  <p className="mb-4" data-id="element-194">
                    Sie können Sie über die bereitgestellten Telefonnummern
                    Kontakt zu uns aufnehmen. Hierbei erheben wir
                    Protokolldaten, die Ihre Telefonnummer und die Dauer des
                    Gesprächs beinhalten.
                  </p>
                  <p className="mb-4" data-id="element-195">
                    Unabhängig von der gewählten Kommunikationsart erheben wir
                    den Inhalt Ihrer Anfrage. Ihre Daten werden zum Zweck der
                    individuellen Kommunikation mit Ihnen gespeichert.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-196">
                    Rechtsgrundlage
                  </h4>
                  <p className="mb-4" data-id="element-197">
                    Die Verarbeitung der Daten erfolgt auf der Grundlage eines
                    berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO). Unser
                    berechtigtes Interesse an der Verarbeitung Ihrer Daten ist
                    die Ermöglichung einer unkomplizierten Kontaktaufnahme.
                    Sofern Sie mit uns Kontakt aufnehmen, um ein Angebot zu
                    erfragen, erfolgt die Verarbeitung der Daten zur
                    Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit.
                    b DSGVO).
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-198">
                    Empfänger
                  </h4>
                  <p className="mb-4" data-id="element-199">
                    Empfänger der Daten sind ggf. technische Dienstleister, die
                    für den Betrieb und die Wartung unserer Webseite als
                    Auftragsverarbeiter tätig werden.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-200">
                    Speicherdauer
                  </h4>
                  <p className="mb-4" data-id="element-201">
                    Daten werden entsprechend der gesetzlichen Vorgaben
                    gelöscht. Sofern es zu einem Vertragsverhältnis kommt,
                    unterliegen wir den gesetzlichen Aufbewahrungsfristen. Diese
                    betragen grundsätzlich 6 oder 10 Jahre aus Gründen der
                    ordnungsmäßigen Buchführung und steuerrechtlichen
                    Anforderungen.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-202">
                    Bereitstellung vorgeschrieben oder erforderlich
                  </h4>
                  <p className="mb-4" data-id="element-203">
                    Die Bereitstellung Ihrer personenbezogenen Daten erfolgt
                    freiwillig. Wir können Ihre Anfrage jedoch nur bearbeiten,
                    sofern Sie uns die erforderlichen Daten und den Grund der
                    Anfrage mitteilen.
                  </p>
                </div>

                <div data-id="element-204">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-205">
                    Hubspot CRM
                  </h3>
                  <p className="mb-4" data-id="element-206">
                    Wir nutzen das Hubspot CRM unter anderem auf dieser Website.
                    Anbieter ist Hubspot Germany GmbH, Am Postbahnhof 17, 10243
                    Berlin, Deutschland (nachfolgend Hubspot CRM).
                  </p>
                  <p className="mb-4" data-id="element-207">
                    Hubspot CRM ermöglicht es uns unter anderem, bestehende und
                    potenzielle Kunden sowie Kundenkontakte zu verwalten. Mit
                    Hilfe von Hubspot CRM sind wir in der Lage,
                    Kundeninteraktionen und Newsletter per E-Mail, Chat, Social
                    Media oder Telefon über verschiedene Kanäle hinweg zu
                    senden, erfassen, zu sortieren und zu analysieren. Die so
                    erfassten personenbezogenen Daten können ausgewertet und für
                    die Kommunikation mit dem potenziellen Kunden oder für
                    Marketingmaßnahmen (z.B. Newsletter Mailings) verwendet
                    werden. Mit Hubspot CRM sind wir ferner in der Lage, das
                    Nutzerverhalten unserer Kontakte auf unserer Website zu
                    erfassen und zu analysieren. Zudem bietet Hubspot das Chat
                    Tool an, welches für den Support und Fragen genutzt werden
                    kann (Cookie-Einwilligung erforderlich).
                  </p>
                  <p className="mb-4" data-id="element-208">
                    Die Verwendung von Hubspot CRM erfolgt auf Grundlage von
                    Art. 6 Abs. 1 lit. f DS-GVO. Der Websitebetreiber hat ein
                    berechtigtes Interesse an einer möglichst effizienten
                    Kundenverwaltung und Kundenkommunikation. Sofern eine
                    entsprechende Einwilligung abgefragt wurde, erfolgt die
                    Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1
                    lit. a DS-GVO; die Einwilligung ist jederzeit widerrufbar.
                    Details entnehmen Sie der Datenschutzerklärung von Hubspot:{' '}
                    <a href="https://legal.hubspot.com/de/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-209">
                      https://legal.hubspot.com/de/privacy-policy
                    </a>
                  </p>
                  <p className="mb-4" data-id="element-210">
                    Wir haben einen Vertrag über Auftragsverarbeitung mit
                    Hubspot CRM geschlossen. Hierbei handelt es sich um einen
                    datenschutzrechtlich vorgeschriebenen Vertrag, der
                    gewährleistet, dass Hubspot CRM die personenbezogenen Daten
                    unserer Websitebesucher nur nach unseren Weisungen und unter
                    Einhaltung der DS-GVO verarbeitet.
                  </p>
                  <p className="mb-4" data-id="element-211">
                    Serverstandort für die Datenverarbeitung von Hubspot ist
                    immer innerhalb der EU.
                  </p>
                  <p className="mb-4" data-id="element-212">
                    Der Versand des Newsletters und die mit ihm verbundene
                    Erfolgsmessung erfolgt auf Grundlage einer Einwilligung der
                    Empfänger gem. Art. 6 Abs. 1 lit. a, Art. 7 DS-GVO i.V.m § 7
                    Abs. 2 Nr. 3 UWG bzw. auf Grundlage der gesetzlichen
                    Erlaubnis gem. § 7 Abs. 3 UWG.
                  </p>
                  <p className="mb-4" data-id="element-213">
                    Der Versanddienstleister darf die Daten der Empfänger in
                    pseudonymer Form, d.h. ohne Zuordnung zu einem Nutzer, zur
                    Optimierung oder Verbesserung der eigenen Dienste, z.B. zur
                    technischen Optimierung des Versandes und der Darstellung
                    der Newsletter oder zu statistischen Zwecken verwenden. Der
                    Versanddienstleister nutzt die Daten unserer
                    Newsletter-Empfänger jedoch nicht, um diese selbst
                    anzuschreiben oder an Dritte weiterzugeben.
                  </p>
                </div>

                <div data-id="element-214">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-215">
                    Google Meet
                  </h3>
                  <p className="mb-4" data-id="element-216">
                    Wir nutzen Google Meet. Anbieter ist die Google Ireland
                    Limited, Gordon House, Barrow Street, Dublin 4, Ireland.
                    Details zur Datenverarbeitung entnehmen Sie der
                    Datenschutzerklärung von Google:{' '}
                    <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-217">
                      https://policies.google.com/privacy?hl=de
                    </a>
                  </p>
                  <p className="mb-4" data-id="element-218">
                    Wir haben mit dem Anbieter von Google Meet einen Vertrag zur
                    Auftragsverarbeitung abgeschlossen und setzen die strengen
                    Vorgaben der deutschen Datenschutzbehörden bei der Nutzung
                    von Google Meet vollständig um.
                  </p>
                  <p className="mb-4" data-id="element-219">
                    Das Unternehmen verfügt über eine Zertifizierung nach dem
                    „EU-US Data Privacy Framework" (DPF). Das DPF ist ein
                    Übereinkommen zwischen der Europäischen Union und den USA,
                    welches die Einhaltung europäischer Datenschutzstandards bei
                    Datenverarbeitungen in den USA gewährleisten soll. Jedes
                    nach dem DPF zertifizierte Unternehmen verpflichtet sich,
                    diese Datenschutzstandards einzuhalten. Weitere
                    Informationen hierzu erhalten Sie vom Anbieter unter
                    folgendem Link:{' '}
                    <a href="https://www.dataprivacyframework.gov/list" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-220">
                      https://www.dataprivacyframework.gov/list
                    </a>
                  </p>
                  <p className="mb-4" data-id="element-221">
                    Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1
                    lit. f DS-GVO. Der Websitebetreiber hat ein berechtigtes
                    Interesse an einer möglichst unkomplizierten
                    Terminvereinbarung mit Interessenten und Kunden. Sofern eine
                    Einwilligung abgefragt wurde, ist Art. 6 Abs. 1 lit. a
                    DS-GVO die Rechtsgrundlage für die Datenverarbeitung; die
                    Einwilligung ist jederzeit widerrufbar.
                  </p>
                </div>

                <div data-id="element-222">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-223">Cookies</h3>
                  <p className="mb-4" data-id="element-224">
                    Ein Cookie ist ein kleiner Datensatz, der beim Besuch einer
                    Website erstellt und auf dem System Websitebesuchers
                    zwischengespeichert wird. Wird der Server dieser Website
                    erneut vom Nutzer der Website aufgerufen, sendet der Browser
                    des Nutzers der Website das zuvor empfangenen Cookie wieder
                    zurück an den Server. Der Server kann die durch dieses
                    Verfahren erhaltenen Informationen auswerten. Durch Cookies
                    kann insbesondere das Navigieren auf einer Website
                    erleichtert werden.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-225">
                    Technisch notwendige Cookies
                  </h4>
                  <p className="mb-4" data-id="element-226">
                    Wir setzen Cookies ein, um unsere Website nutzerfreundlicher
                    zu gestalten. Einige Elemente unserer Website erfordern es,
                    dass der aufrufende Browser auch nach einem Seitenwechsel
                    identifiziert werden kann.
                  </p>
                  <p className="mb-4" data-id="element-227">
                    Der Zweck der Verwendung technisch notwendiger Cookies ist,
                    die Nutzung von Websites für die Nutzer zu vereinfachen.
                    Einige Funktionen unserer Website können ohne den Einsatz
                    von Cookies nicht angeboten werden. Für diese ist es
                    erforderlich, dass der Browser auch nach einem Seitenwechsel
                    wiedererkannt wird.
                  </p>

                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-228">
                    Rechtsgrundlage und berechtigtes Interesse
                  </h4>
                  <p className="mb-4" data-id="element-229">
                    Die Datenverarbeitung erfolgt insoweit allein auf Basis
                    unseres berechtigten Interesses an einer nutzerfreundlichen
                    Gestaltung unserer Website und an der Dokumentation der
                    Einwilligung gem. Art. 6 Abs. 1 lit. f DSGVO in Verbindung
                    mit einer Abwägung nach §25 Abs. 2 TDDDG.
                  </p>
                </div>
              </div>
            </section>

            <div className="h-px w-full bg-white/10 my-12" data-id="element-230" />

            <section data-id="element-231">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-232">
                Sonstige Plugins und Tools
              </h2>

              <div className="space-y-10" data-id="element-233">
                <div data-id="element-234">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-235">
                    Google Fonts
                  </h3>
                  <p className="mb-4" data-id="element-236">
                    Diese Seite nutzt zur einheitlichen Darstellung von
                    Schriftarten so genannte Web Fonts, die von Google Ireland
                    Limited („Google"), Gordon House, Barrow Street, Dublin 4,
                    Ireland bereitgestellt werden. Beim Aufruf einer Seite lädt
                    Ihr Browser die benötigten Web Fonts in ihren Browsercache,
                    um Texte und Schriftarten korrekt anzuzeigen.
                  </p>
                  <p className="mb-4" data-id="element-237">
                    Zu diesem Zweck muss der von Ihnen verwendete Browser
                    Verbindung zu den Servern von Google aufnehmen. Hierdurch
                    erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse
                    diese Website aufgerufen wurde. Die Nutzung von Google
                    WebFonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
                    DS-GVO. Der Websitebetreiber hat ein berechtigtes Interesse
                    an der einheitlichen Darstellung des Schriftbildes auf
                    seiner Website. Sofern eine entsprechende Einwilligung
                    abgefragt wurde (z. B. eine Einwilligung zur Speicherung von
                    Cookies), erfolgt die Verarbeitung ausschließlich auf
                    Grundlage von Art. 6 Abs. 1 lit. a DS-GVO; die Einwilligung
                    ist jederzeit widerrufbar.
                  </p>
                  <p className="mb-4" data-id="element-238">
                    Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine
                    Standardschrift von Ihrem Computer genutzt.
                  </p>
                  <p className="mb-4" data-id="element-239">
                    Das Unternehmen verfügt über eine Zertifizierung nach dem
                    „EU-US Data Privacy Framework" (DPF). Das DPF ist ein
                    Übereinkommen zwischen der Europäischen Union und den USA,
                    welches die Einhaltung europäischer Datenschutzstandards bei
                    Datenverarbeitungen in den USA gewährleisten soll. Jedes
                    nach dem DPF zertifizierte Unternehmen verpflichtet sich,
                    diese Datenschutzstandards einzuhalten. Weitere
                    Informationen hierzu erhalten Sie vom Anbieter unter
                    folgendem Link:{' '}
                    <a href="https://www.dataprivacyframework.gov/list" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-240">
                      https://www.dataprivacyframework.gov/list
                    </a>
                  </p>
                  <p className="mb-4" data-id="element-241">
                    Weitere Informationen zu Google Web Fonts finden Sie unter{' '}
                    <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-242">
                      https://developers.google.com/fonts/faq
                    </a>{' '}
                    und in der Datenschutzerklärung von Google:{' '}
                    <a href="https://www.google.com/policies/privacy" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-243">
                      https://www.google.com/policies/privacy
                    </a>
                    . Opt-Out:{' '}
                    <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-244">
                      https://adssettings.google.com/authenticated
                    </a>
                  </p>
                </div>

                <div data-id="element-245">
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-246">
                    IONOS WebAnalytics
                  </h3>
                  <p className="mb-4" data-id="element-247">
                    Diese Website nutzt die Analysedienste von IONOS
                    WebAnalytics (im Folgenden: IONOS). Anbieter ist die 1&1
                    IONOS SE, Elgendorfer Straße 57, D – 56410 Montabaur.
                  </p>
                  <p className="mb-4" data-id="element-248">
                    Im Rahmen der Analysen mit IONOS können u. a. Besucherzahlen
                    und –verhalten (z. B. Anzahl der Seitenaufrufe, Dauer eines
                    Webseitenbesuchs, Absprungraten), Besucherquellen (d. h.,
                    von welcher Seite der Besucher kommt), Besucherstandorte
                    sowie technische Daten (Browser- und
                    Betriebssystemversionen) analysiert werden.
                  </p>
                  <p className="mb-2" data-id="element-249">
                    Zu diesem Zweck speichert IONOS insbesondere folgende Daten:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mb-4" data-id="element-250">
                    <li data-id="element-251">Referrer (zuvor besuchte Webseite)</li>
                    <li data-id="element-252">angeforderte Webseite oder Datei</li>
                    <li data-id="element-253">Browsertyp und Browserversion</li>
                    <li data-id="element-254">verwendetes Betriebssystem</li>
                    <li data-id="element-255">verwendeter Gerätetyp</li>
                    <li data-id="element-256">Uhrzeit des Zugriffs</li>
                    <li data-id="element-257">
                      IP-Adresse in anonymisierter Form (wird nur zur
                      Feststellung des Orts des Zugriffs verwendet)
                    </li>
                  </ul>
                  <p className="mb-4" data-id="element-258">
                    Die Datenerfassung erfolgt laut IONOS vollständig
                    anonymisiert, sodass sie nicht zu einzelnen Personen
                    zurückverfolgt werden kann. Cookies werden von IONOS
                    WebAnalytics nicht gespeichert.
                  </p>
                  <p className="mb-4" data-id="element-259">
                    Die Speicherung und Analyse der Daten erfolgt auf Grundlage
                    von Art. 6 Abs. 1 lit. f DS-GVO. Der Websitebetreiber hat
                    ein berechtigtes Interesse an der statistischen Analyse des
                    Nutzerverhaltens, um sowohl sein Webangebot als auch seine
                    Werbung zu optimieren. Sofern eine entsprechende
                    Einwilligung abgefragt wurde, erfolgt die Verarbeitung
                    ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
                    DS-GVO; die Einwilligung ist jederzeit widerrufbar.
                  </p>
                  <p className="mb-4" data-id="element-260">
                    Weitere Informationen zur Datenerfassung und Verarbeitung
                    durch IONOS WebAnalytics entnehmen Sie der
                    Datenschutzerklärung von IONOS unter folgendem Link:{' '}
                    <a href="https://www.ionos.de/terms-gtc/index.php?id=6" target="_blank" rel="noopener noreferrer" className="text-lime hover:underline" data-id="element-261">
                      https://www.ionos.de/terms-gtc/index.php?id=6
                    </a>
                  </p>
                  <p className="mb-4" data-id="element-262">
                    Wir haben mit IONOS einen Vertrag zur Auftragsverarbeitung
                    abgeschlossen. Dieser Vertrag soll den datenschutzkonformen
                    Umgang mit Ihren personenbezogenen Daten durch IONOS
                    sicherstellen.
                  </p>
                </div>
              </div>
            </section>

            <div className="h-px w-full bg-white/10 my-12" data-id="element-263" />

            <section data-id="element-264">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-265">
                Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO
              </h2>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-266">
                Einzelfallbezogenes Widerspruchsrecht
              </h3>
              <p className="mb-4" data-id="element-267">
                Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
                Situation ergeben, jederzeit gegen die Verarbeitung Sie
                betreffender personenbezogener Daten, die aufgrund Art. 6 Abs. 1
                lit. f DSGVO (Datenverarbeitung auf der Grundlage einer
                Interessenabwägung) erfolgt, Widerspruch einzulegen; dies gilt
                auch für ein auf diese Bestimmung gestütztes Profiling im Sinne
                von Art. 4 Nr. 4 DSGVO.
              </p>
              <p className="mb-4" data-id="element-268">
                Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen
                Daten nicht mehr verarbeiten, es sei denn, wir können zwingende
                schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre
                Interessen, Rechte und Freiheiten überwiegen, oder die
                Verarbeitung dient der Geltendmachung, Ausübung oder
                Verteidigung von Rechtsansprüchen.
              </p>
            </section>

            <section data-id="element-269">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-270">
                Änderung unserer Datenschutzerklärung
              </h2>
              <p className="mb-4" data-id="element-271">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen,
                damit sie stets den aktuellen rechtlichen Anforderungen
                entspricht oder um Änderungen unserer Leistungen in der
                Datenschutzerklärung umzusetzen, z.B. bei der Einführung neuer
                Services. Für Ihren erneuten Besuch gilt dann die neue
                Datenschutzerklärung.
              </p>
            </section>
          </div>
        </div>
        <CTA data-id="element-272" />
      </main>
    </>;
}